// extracted by mini-css-extract-plugin
export var darkMode = "_n-0";